import { Station } from '@mi-front/core';
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  SelectProps,
} from '@mui/material';
import { useIntl } from 'react-intl';

export const StationsInputMui = ({
  stations,
  multiple,
  value,
  onChange,
  selectProps,
}: {
  stations: readonly Station[];
  multiple?: boolean;
  value?: Station;
  onChange: (value: Station) => void;
  selectProps?: Omit<SelectProps<string>, 'onChange'>;
}) => {
  const { $t } = useIntl();

  const handleChange = (event: SelectChangeEvent<string>) => {
    const selectedStation = stations.find((station) => station?.id === event.target.value);
    if (selectedStation) {
      onChange(selectedStation);
    }
  };

  return (
    <FormControl fullWidth>
      <InputLabel id="station-select-label">
        {selectProps?.label ??
          $t({
            id: 'common.station',
            defaultMessage: 'Emisora',
          })}
      </InputLabel>
      <Select
        labelId="station-select-label"
        id="station-select"
        label={$t({
          id: 'common.station',
          defaultMessage: 'Emisora',
        })}
        value={value?.id}
        onChange={handleChange}
        multiple={multiple}
        {...selectProps}
      >
        {stations.map((station) => (
          <MenuItem key={station.id} value={station.id}>
            {station.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
